import { Heading, Layout, Loader, Spacer } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Column } from 'simple-flexbox'

import { PurchaseSummaryPanel } from '../components/PurchaseSummaryPanel'
import { useCheckoutContext } from '../contexts'
import { Billing } from './components/Billing'
import { PaymentMethod } from './components/PaymentMethod'
import styles from './Payment.module.scss'

export const Payment = () => {
  const { t } = useTranslation()

  const { packagesIsLoading } = useCheckoutContext()

  return (
    <Layout width={1070}>
      <Spacer space={40} />

      {packagesIsLoading ? (
        <Loader />
      ) : (
        <div className={styles.payment__container}>
          <Column>
            <Heading weight={600}>{t('checkout.payment.heading')}</Heading>

            <Spacer space={30} />

            <form>
              <Billing />

              <Spacer space={30} />

              <PaymentMethod />
            </form>

            <Spacer space={30} />
          </Column>

          <PurchaseSummaryPanel />
        </div>
      )}
    </Layout>
  )
}

Payment.displayName = 'CheckoutPayment'
